"use client";

import { createContext, useContext, useState } from "react";

interface ShortsContextType {
  isMuted: boolean;
  setIsMuted: React.Dispatch<React.SetStateAction<boolean>>;
}

const ShortsContext = createContext<ShortsContextType | null>(null);

export const ShortsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isMuted, setIsMuted] = useState(true);

  return (
    <ShortsContext.Provider value={{ isMuted, setIsMuted }}>{children}</ShortsContext.Provider>
  );
};

export const useShortsContext = () => {
  const context = useContext(ShortsContext);
  if (!context) {
    throw new Error("useMyContext must be used within a MyContextProvider");
  }
  return context;
};
